<p>inventario works!</p>
